// @flow
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './BannerOutdatedBrowser.module.scss';

type Props = {|
    majorVersion: number,
    name: string,
|};

const BannerOutdatedBrowser = (props: Props) => {
    const { majorVersion, name } = props;

    const formalName = <FormattedMessage id={name} />;
    const chrome = (
        <Link rel="noopener" target="_blank" to="https://www.google.com/chrome/browser/desktop/">
            <FormattedMessage id="chrome" />
        </Link>
    );
    const firefox = (
        <Link rel="noopener" target="_blank" to="https://www.mozilla.org/en-US/firefox/new/">
            <FormattedMessage id="firefox" />
        </Link>
    );
    const edge = (
        <Link rel="noopener" target="_blank" to="https://www.microsoft.com/en-us/windows/microsoft-edge">
            <FormattedMessage id="edge" />
        </Link>
    );
    const safari = (
        <Link rel="noopener" target="_blank" to="https://support.apple.com/downloads/safari">
            <FormattedMessage id="safari" />
        </Link>
    );

    return (
        <div className={styles['la-notification-bar']}>
            <div className={styles['notification-message']}>
                <div className={styles['message-status']}>
                    <FontAwesomeIcon className={styles.icon} icon={faExclamationCircle} />
                </div>
                <div className={styles['message-body']}>
                    <span className={styles['message-headline']}>
                        <FormattedMessage
                            id="did_you_know_that_your_web_browser"
                            values={{ formalName, majorVersion }}
                        />
                    </span>
                    <div>
                        <FormattedMessage
                            id="browsers_for_best_experience"
                            values={{ chrome, edge, firefox, safari }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(BannerOutdatedBrowser);
